import { PrivacyTypes, ProfileV2 } from '../../../types';

export default function ({ hasResume, profilePrivacy }: ProfileV2): boolean {
  return hasResume !== null ? profilePrivacy === PrivacyTypes.Standard : false;
}
